import background1 from './images/islide-more-pic1.svg'
import background2 from './images/islide-more-pic2.svg'
import bannerLeftEn from './images/islide-banner-left-en.svg'
import bannerLeftZh from './images/islide-banner-left.svg'
import bannerRight from './images/islide-banner-right.png'
import iconBenifit1 from './images/islide-icon-1.svg'
import iconBenifit2 from './images/islide-icon-2.svg'
import iconBenifit3 from './images/islide-icon-3.svg'
import iconBenifit4 from './images/islide-icon-4.svg'

import more1 from './images/islide-more-1.svg'
import more2 from './images/islide-more-2.svg'
import more3 from './images/islide-more-3.svg'
import more4 from './images/islide-more-4.svg'
import more5 from './images/islide-more-5.svg'
import more6 from './images/islide-more-6.svg'

export const getConstants = prop => Constants[prop]

const pageName = 'islide'

export const appBanner = {
	pageName,
	bannerEn: bannerLeftEn.url,
	bannerZh: bannerLeftZh.url,
	bannerDisplay: bannerRight,
}

export const appBenifit = {
	title: getConstants('ISLIDE_LANDING_BENIFIT_TITLE'),
	subTitle: getConstants('ISLIDE_LANDING_BENIFIT_SUBTITLE'),
	list: [
		{
			title: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK1_TITLE'),
			before: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK1_BEFORE'),
			after: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK1_AFTER'),
			icon: iconBenifit1.url,
		},
		{
			before: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK2_BEFORE'),
			after: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK2_AFTER'),
			title: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK2_TITLE'),
			icon: iconBenifit2.url,
		},
		{
			title: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK3_TITLE'),
			before: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK3_BEFORE'),
			after: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK3_AFTER'),
			icon: iconBenifit3.url,
		},
		{
			title: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK4_TITLE'),
			before: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK4_BEFORE'),
			after: getConstants('ISLIDE_LANDING_BENIFIT_BLOCK4_AFTER'),
			icon: iconBenifit4.url,
		},
	],
}

export const appSale = {
	advanced: {
		title: getConstants('ISLIDE_LANDING_SALE_ADVANCE_TITLE'),
		subTitle: getConstants('ISLIDE_LANDING_SALE_ADVANCE_SUBTITLE'),
		originPrice: getConstants('ISLIDE_LANDING_SALE_ADVANCE_ORIGIN_PRICE'),
		edition: getConstants('EAGLE_LANDING_SALE_ADVANCE_EDITION'),
		saleText1: getConstants('EAGLE_LANDING_SALE_ADVANCE_TEXT1'),
		saleText2: getConstants('EAGLE_LANDING_SALE_ADVANCE_TEXT2'),
		saleText3: getConstants('EAGLE_LANDING_SALE_ADVANCE_TEXT3'),
		saleTip: getConstants('EAGLE_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('EAGLE_LANDING_SALE_UPDATE'),
	},
	pro: {
		title: getConstants('ISLIDE_LANDING_SALE_PRO_TITLE'),
		subTitle: getConstants('ISLIDE_LANDING_SALE_PRO_SUBTITLE'),
		originPrice: getConstants('ISLIDE_LANDING_SALE_PRO_ORIGIN_PRICE'),
		edition: getConstants('EAGLE_LANDING_SALE_PRO_EDITION'),
		saleText1: getConstants('EAGLE_LANDING_SALE_PRO_TEXT1'),
		saleText2: getConstants('EAGLE_LANDING_SALE_PRO_TEXT2'),
		saleText3: getConstants('EAGLE_LANDING_SALE_PRO_TEXT3'),
		saleTip: getConstants('EAGLE_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('EAGLE_LANDING_SALE_UPDATE'),
	},
	extra: {
		noTip: true,
		title: getConstants('ISLIDE_LANDING_SALE_LICENSE'),
		list: [
			getConstants('ISLIDE_LANDING_SALE_LICENSE_TEXT1'),
			getConstants('ISLIDE_LANDING_SALE_LICENSE_TEXT2'),
		],
	},
}

export const paidModal = {
	name: getConstants('ISLIDE_LANDING_SALE_PAID_NAME'),
	content: getConstants('ISLIDE_LANDING_SALE_PAID_CONTENT'),
	tip: getConstants('ISLIDE_LANDING_SALE_PAID_TIP'),
	price: getConstants('ISLIDE_LANDING_SALE_PAID_PRICE'),
	plan: getConstants('ISLIDE_LANDING_SALE_PLAN'),
	pro: {
		title: getConstants('ISLIDE_LANDING_SALE_PRO_TITLE'),
		originPrice: '¥ 459',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_PRO'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_360'),
	},
	advance: {
		title: getConstants('ISLIDE_LANDING_SALE_ADVANCE_TITLE'),
		originPrice: '¥ 819',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_ADVANCE'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_720'),
	},
}

export const appRecommend = {
	title: getConstants('ISLIDE_LANDING_RECOMMEND_TITLE'),
	subTitle: getConstants('ISLIDE_LANDING_RECOMMEND_SUBTITLE'),
	style: {
		text: {
			height: '120px',
		},
		block: {
			width: '500px',
		},
	},
	blocks: [
		{
			text: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK1_TEXT'),
			name: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK1_USER'),
			company: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK1_COMPANY'),
		},
		{
			text: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK2_TEXT'),
			name: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK2_USER'),
			company: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK2_COMPANY'),
		},
		{
			text: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK3_TEXT'),
			name: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK3_USER'),
			company: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK3_COMPANY'),
		},
		{
			text: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK4_TEXT'),
			name: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK4_USER'),
			company: getConstants('ISLIDE_LANDING_RECOMMEND_BLOCK4_COMPANY'),
		},
	],
}

export const appFaq = [1, 2, 3, 4, 5, 6, 7, 8].map(num => ({
	title: getConstants(`ISLIDE_LANDING_FAQ_DETAIL_TITLE${num}`),
	text: getConstants(`ISLIDE_LANDING_FAQ_DETAIL_TEXT${num}`),
}))

export const appMore = [
	{
		title: getConstants('EAGLE_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('EAGLE_LANDING_MORE_NUTSTORE_SUBTITLE'),
		texts1: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT3'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT4'),
		],
		texts2: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT6'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT7'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT8'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT9'),
		],
	},
	{
		title: getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('ISLIDE_LANDING_MORE_NUTSTORE_SUBTITLE'),
		src1: background1.url,
		src2: background2.url,
		texts1: [
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT3'),
		],
		icons1: [more1, more2, more3],
		texts2: [
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT4'),
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('ISLIDE_LANDING_MORE_NUTSTORE_TEXT6'),
		],
		icons2: [more4, more5, more6],
	},
]

export const appHeader = {
	pageName,
}
